import { render, staticRenderFns } from "./stop_stale_environments_modal.vue?vue&type=template&id=6b3976af"
import script from "./stop_stale_environments_modal.vue?vue&type=script&lang=js"
export * from "./stop_stale_environments_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports